<div class="banner">
  <!-- <p>**5 free photos remaining**</p> -->
  <div class="upgrade">
    <p>🕒 Trial Mode</p>
    <div class="dts-button gradient-fill" (click)="app.toggleTrialUpgradeModal('footer-banner')">
      Upgrade Your Account
    </div>
  </div>
</div>
